import { render, staticRenderFns } from "./SnackbarMessage.vue?vue&type=template&id=326c6b22&"
import script from "./SnackbarMessage.vue?vue&type=script&lang=js&"
export * from "./SnackbarMessage.vue?vue&type=script&lang=js&"
import style0 from "./SnackbarMessage.vue?vue&type=style&index=0&id=326c6b22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports